export default {
    id: null,
    order_id: null,
    filename: null,
    hear_date: null,
    created_at: null,
    source: null,
    archive: null
}
